module.exports = "https://vote4-campaigns-cdn.fire-emblem-heroes.com/images/src/assets/images/select-type/zh-TW/btn_select-text-title.png";